import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AdminForgotPasswordService } from '../services/admin-forgot-password.service';
import { AppUtils } from '../../../core/config/app.utils';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: any;
  formErrors: any;
  isEmailSent = false;
  emailForResend: any;
  msg: any = {
    icon: '',
    type: '',
    message: '',
  };

  constructor(
    private fb: FormBuilder,
    private adminForgotPwdService: AdminForgotPasswordService
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
    });
    this.forgotPasswordForm.valueChanges.subscribe(() => {
      this.formErrors = AppUtils.getFormErrors(
        this.forgotPasswordForm,
        this.formErrors
      );
    });

    this.adminForgotPwdService.onReqResetPasswordResponseChange.subscribe(
      res => {
        if (res.done) {
          this.isEmailSent = true;
        }
      }
    );
  }

  sendEmail(emailForResend?: any): void {
    const url = `${location.origin}`;
    if (!this.isEmailSent) {
      const { email } = this.forgotPasswordForm.getRawValue();
      this.adminForgotPwdService
        .requestResetPassword({ url, email })
        .then(res => {
          this.msg = res;
        });
      this.emailForResend = email;
    } else {
      this.adminForgotPwdService
        .requestResetPassword({ url, emailForResend })
        .then();
    }
  }
}
